
/* Map section */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.section-map').forEach((section) => {
        const mapContainer = section.querySelector('.map-container');
        const listItems = section.querySelectorAll('.list-item');
        const pins = section.querySelectorAll('.pin');
        const previewBox = section.querySelector('.preview-box');
        const previewImg =
            previewBox?.querySelector('.preview-image-container img') ??
            previewBox?.querySelector('img');
        const previewDesc =
            previewBox?.querySelector('.map-preview-desc') ??
            previewBox?.querySelector('.preview-text p') ??
            previewBox?.querySelector('p');
        const mapDescription = section.querySelector('.map-description');
        const defaultMapDescriptionHtml = mapDescription?.innerHTML ?? '';

        if (!mapContainer || !previewBox || !previewImg || !previewDesc) return;

        let currentId = null;
        let lockedId = null;

        const isDesktopHover = () => window.innerWidth >= 1024;

        function setActive(id, data = null) {
            pins.forEach((p) => p.classList.remove('active'));
            listItems.forEach((li) => li.classList.remove('active'));

            if (!id) {
                mapContainer.classList.remove('active');
                previewBox.classList.remove('visible');
                previewDesc.innerHTML = '';
                if (mapDescription) mapDescription.innerHTML = defaultMapDescriptionHtml;
                currentId = null;
                return;
            }

            currentId = id;
            mapContainer.classList.add('active');

            const targetPin = mapContainer.querySelector(`.pin[data-id="${id}"]`);
            if (targetPin) targetPin.classList.add('active');

            const targetItem = section.querySelector(`.list-item[data-id="${id}"]`);
            if (targetItem) targetItem.classList.add('active');

            if (data) {
                if (data.img) previewImg.src = data.img;
                if (data.title) previewImg.alt = data.title;
                previewDesc.innerHTML = data.descHtml ?? '';
                if (mapDescription) mapDescription.innerHTML = data.descHtml ?? '';
                previewBox.classList.add('visible');
            }
        }

        function readListItemData(item) {
            const descHost = item.querySelector('.list-item-desc-html');
            return {
                title: item.getAttribute('data-title'),
                descHtml: descHost ? descHost.innerHTML : '',
                img: item.getAttribute('data-img')
            };
        }

        function activateFromHover(id, data) {
            if (!isDesktopHover() || lockedId) return;
            setActive(id, data);
        }

        function deactivateFromHover() {
            if (!isDesktopHover() || lockedId) return;
            setActive(null);
        }

        function handleActivateClick(id, data) {
            if (lockedId === id) {
                lockedId = null;
                setActive(null);
                return;
            }
            lockedId = id;
            setActive(id, data);
        }

        listItems.forEach((item) => {
            const id = item.getAttribute('data-id');
            const data = readListItemData(item);

            item.addEventListener('mouseenter', () => activateFromHover(id, data));
            item.addEventListener('mouseleave', deactivateFromHover);
            item.addEventListener('click', () => handleActivateClick(id, data));
        });

        pins.forEach((pin) => {
            const id = pin.getAttribute('data-id');
            const listItem = section.querySelector(`.list-item[data-id="${id}"]`);
            if (!listItem) return;

            const data = readListItemData(listItem);

            pin.addEventListener('mouseenter', () => activateFromHover(id, data));
            pin.addEventListener('mouseleave', deactivateFromHover);
            pin.addEventListener('click', () => handleActivateClick(id, data));
        });
    });
});
/* end Map section */

/* Sculptures section */
const SCULPTURES_MOBILE_MQ = '(max-width: 834px)';

function isSculpturesMobileViewport() {
    return window.matchMedia(SCULPTURES_MOBILE_MQ).matches;
}

/** counter_number hiển thị: 0–9 → 00–09, 10+ giữ nguyên */
function formatSculptureCounterDisplay(id) {
    const n = Math.trunc(Number(id));
    if (!Number.isFinite(n) || n < 0) {
        return id == null || id === '' ? '' : String(id);
    }
    if (n < 10) {
        return `0${n}`;
    }
    return String(n);
}

function getSculpturesStickyHeaderOffsetPx() {
    let h = 0;
    const ann = document.querySelector('[data-section-type="announcement-bar"]');
    if (ann && !ann.classList.contains('hidden') && ann.offsetHeight > 0) {
        h += ann.offsetHeight;
    }
    const header = document.querySelector('#shopify-section-header');
    if (header && header.offsetHeight > 0) {
        h += header.offsetHeight;
    }
    return Math.max(0, Math.round(h));
}

function applySculpturesHeaderOffsetToDom() {
    const px = getSculpturesStickyHeaderOffsetPx();
    const value = `${px}px`;
    document.querySelectorAll('.section-sculptures').forEach((root) => {
        root.style.setProperty('--sculptures-header-offset', value);
    });
}

function readSculpturesHeaderOffsetPx(root) {
    const raw = getComputedStyle(root).getPropertyValue('--sculptures-header-offset').trim();
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 80;
}

function readSculpturesCssLengthPx(root, cssVarName, fallbackRatio) {
    const raw = getComputedStyle(root).getPropertyValue(cssVarName).trim();
    const match = raw.match(/^([\d.]+)(vh|svh|px)$/i);
    if (!match) return Math.round(window.innerHeight * fallbackRatio);
    const amount = parseFloat(match[1]);
    if (!Number.isFinite(amount)) return Math.round(window.innerHeight * fallbackRatio);
    const unit = match[2].toLowerCase();
    if (unit === 'px') return Math.round(amount);
    return Math.round((window.innerHeight * amount) / 100);
}

function readSculpturesScrollRunwayPx(root) {
    return readSculpturesCssLengthPx(root, '--sculptures-scroll-runway', 0.2);
}

function readSculpturesState2ThresholdPx(root) {
    return readSculpturesCssLengthPx(root, '--sculptures-state2-threshold', 0.12);
}

function readSculpturesAccFadeThresholdPx(root) {
    return readSculpturesCssLengthPx(root, '--sculptures-desktop-acc-fade-threshold', 0.5);
}

function readSculpturesMobileAccFadeOffsetPx(root) {
    return readSculpturesCssLengthPx(root, '--sculptures-mobile-acc-fade-offset', 0.5);
}

function onWindowResizeForSculptures() {
    applySculpturesHeaderOffsetToDom();
    document.querySelectorAll('.section-sculptures').forEach((root) => {
        root.dispatchEvent(new CustomEvent('sculptures-internal-resize', { bubbles: false }));
    });
}

function readSculpturesDataFromSection(sectionRoot) {
    const el = sectionRoot.querySelector('script.sculptures-data-json[type="application/json"]');
    if (!el) return [];
    try {
        const data = JSON.parse(el.textContent.trim());
        return Array.isArray(data) ? data : [];
    } catch {
        return [];
    }
}

function getSculpturePrimaryVideoUrl(s) {
    return typeof s?.video === 'string' && s.video.length > 0 ? s.video : '';
}

function getSculptureSafariVideoUrl(s) {
    return typeof s?.video_safari === 'string' && s.video_safari.length > 0 ? s.video_safari : '';
}

function isSafariWebKitBrowser() {
    const ua = navigator.userAgent || '';
    return /AppleWebKit/i.test(ua) && !/Chrome|CriOS|Chromium|EdgA|EdgiOS|OPR|FxiOS|Firefox/i.test(ua);
}

/** Safari: only HEVC safari file; otherwise primary_image. Other browsers: WebM, then safari MP4. */
function sculptureUsesVideoOnThisBrowser(s) {
    if (isSafariWebKitBrowser()) {
        return !!getSculptureSafariVideoUrl(s);
    }
    return !!(getSculpturePrimaryVideoUrl(s) || getSculptureSafariVideoUrl(s));
}

function getSculpturePrimaryImageUrl(s) {
    return typeof s?.img === 'string' && s.img.length > 0 ? s.img : '';
}

function setSculptureVideoSource(video, s) {
    const safariUrl = getSculptureSafariVideoUrl(s);
    const webmUrl = getSculpturePrimaryVideoUrl(s);

    if (isSafariWebKitBrowser()) {
        if (safariUrl) video.src = safariUrl;
        return;
    }

    if (webmUrl) {
        video.src = webmUrl;
        return;
    }
    if (safariUrl) video.src = safariUrl;
}

function clearSculptureMediaContainer(el) {
    if (!el) return;
    el.classList.remove('sculpture-media--video-ready');
    el.style.backgroundImage = '';
    el.querySelectorAll('video.sculpture-primary-video').forEach((v) => v.remove());
}

function revealSculptureVideoWhenReady(containerEl, video) {
    if (!containerEl || !video) return;
    const reveal = () => {
        containerEl.classList.add('sculpture-media--video-ready');
    };
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        reveal();
        return;
    }
    video.addEventListener('loadeddata', reveal, { once: true });
    video.addEventListener('canplay', reveal, { once: true });
}

function autoplaySculpturePrimaryVideo(video) {
    if (!video) return;
    const play = () => {
        video.play().catch(() => {});
    };
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        play();
    } else {
        video.addEventListener('loadeddata', play, { once: true });
    }
}

function applySculpturePrimaryMedia(containerEl, s, options = {}) {
    clearSculptureMediaContainer(containerEl);
    if (!containerEl || !s) return null;

    const imgUrl = getSculpturePrimaryImageUrl(s);
    if (imgUrl) {
        containerEl.style.backgroundImage = `url(${JSON.stringify(imgUrl)})`;
    }

    if (sculptureUsesVideoOnThisBrowser(s)) {
        const video = document.createElement('video');
        video.className = 'sculpture-primary-video';
        setSculptureVideoSource(video, s);
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        if (options.autoplay) {
            video.autoplay = true;
            video.setAttribute('autoplay', '');
            video.preload = 'auto';
        } else {
            video.preload = 'metadata';
            video.pause();
        }
        containerEl.appendChild(video);
        revealSculptureVideoWhenReady(containerEl, video);
        if (options.autoplay) {
            autoplaySculpturePrimaryVideo(video);
        }
        return video;
    }
    return null;
}

function ensureSculptureVideoHoverZone(zoneEl) {
    if (!zoneEl || zoneEl.dataset.sculptureVideoHoverBound === 'true') return;
    zoneEl.dataset.sculptureVideoHoverBound = 'true';
    zoneEl.addEventListener('mouseenter', () => {
        zoneEl.querySelector('video.sculpture-primary-video')?.play().catch(() => {});
    });
    zoneEl.addEventListener('mouseleave', () => {
        zoneEl.querySelector('video.sculpture-primary-video')?.pause();
    });
}

function buildMechanismCells(urls) {
    const frag = document.createDocumentFragment();
    urls.forEach((url, i) => {
        const cell = document.createElement('div');
        cell.className = 'mechanism-cell';
        const box = document.createElement('div');
        box.className = 'mechanism-box';
        box.style.backgroundImage = `url(${JSON.stringify(url)})`;
        const cap = document.createElement('span');
        cap.className = 'mechanism-caption';
        cap.textContent = `( ${String(i + 1).padStart(2, '0')} )`;
        cell.appendChild(box);
        cell.appendChild(cap);
        frag.appendChild(cell);
    });
    return frag;
}

const SCULPTURES_DETAIL_NAV_COOLDOWN_MS = 420;
const SCULPTURES_DETAIL_SWIPE_THRESHOLD_PX = 36;

function getActiveSculptureIndexFromList(indexList) {
    const active = indexList?.querySelector('li.active');
    if (!active) return 0;
    const idx = parseInt(active.dataset.sculptureIndex, 10);
    return Number.isNaN(idx) ? 0 : idx;
}

function stepSculptureIndexCircular(current, delta, count) {
    if (count <= 0) return 0;
    return (((current + delta) % count) + count) % count;
}

function bindSculptureDetailImageNavigation(imgEl, indexList, itemCount, onIndexChange) {
    if (!imgEl || !indexList || itemCount <= 1 || typeof onIndexChange !== 'function') return;

    let lastNavigateAt = 0;
    let touchStartY = 0;
    let touchStartX = 0;
    let touchActive = false;

    const navigateByDelta = (delta) => {
        const now = Date.now();
        if (now - lastNavigateAt < SCULPTURES_DETAIL_NAV_COOLDOWN_MS) return;
        const current = getActiveSculptureIndexFromList(indexList);
        const next = stepSculptureIndexCircular(current, delta, itemCount);
        if (next === current) return;
        lastNavigateAt = now;
        onIndexChange(next);
    };

    imgEl.addEventListener(
        'wheel',
        (e) => {
            if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
            e.preventDefault();
            navigateByDelta(e.deltaY > 0 ? 1 : -1);
        },
        { passive: false }
    );

    imgEl.addEventListener(
        'touchstart',
        (e) => {
            const touch = e.touches[0];
            if (!touch) return;
            touchStartY = touch.clientY;
            touchStartX = touch.clientX;
            touchActive = true;
        },
        { passive: true }
    );

    imgEl.addEventListener(
        'touchend',
        (e) => {
            if (!touchActive) return;
            touchActive = false;
            const touch = e.changedTouches[0];
            if (!touch) return;
            const dy = touchStartY - touch.clientY;
            const dx = touchStartX - touch.clientX;
            if (Math.abs(dy) < SCULPTURES_DETAIL_SWIPE_THRESHOLD_PX || Math.abs(dy) < Math.abs(dx)) return;
            navigateByDelta(dy > 0 ? 1 : -1);
        },
        { passive: true }
    );

    imgEl.addEventListener(
        'touchcancel',
        () => {
            touchActive = false;
        },
        { passive: true }
    );
}

function initSculpturesSection(sectionRoot) {
    const sculpturesData = readSculpturesDataFromSection(sectionRoot);
    const scentSection = sectionRoot.querySelector('.scent-experience-wrapper');
    const wrapper = sectionRoot.querySelector('.carousel-wrapper');
    const panelOverlay = sectionRoot.querySelector('.sculptures-panel-overlay');
    const mobilePanelOverlay = sectionRoot.querySelector('.sculptures-mobile-panel-overlay');
    const desktopAccordion = sectionRoot.querySelector('[data-sculptures-desktop-accordion]');
    const desktopIndexList = sectionRoot.querySelector('.sculptures-desktop-index');
    const desktopTitle = sectionRoot.querySelector('.sculptures-desktop-detail-title');
    const desktopDesc = sectionRoot.querySelector('.sculptures-desktop-detail-desc');
    const desktopMainImg = sectionRoot.querySelector('.sculptures-desktop-detail-img');
    const desktopMechanismsBlock = sectionRoot.querySelector('.sculptures-desktop-mechanisms');
    const desktopMechanismsGrid = sectionRoot.querySelector('.sculptures-desktop-mechanisms-grid');
    const mobileAccordion = sectionRoot.querySelector('[data-sculptures-mobile-accordion]');
    const mobileIndexList = sectionRoot.querySelector('.sculptures-mobile-index');
    const mobileTitle = sectionRoot.querySelector('.sculptures-mobile-detail-title');
    const mobileDesc = sectionRoot.querySelector('.sculptures-mobile-detail-desc');
    const mobileMainImg = sectionRoot.querySelector('.sculptures-mobile-detail-img');
    const mobileMechanismsWrap = sectionRoot.querySelector('.sculptures-mobile-acc__detail-mech');
    const mobileMechanismsGrid = sectionRoot.querySelector('.sculptures-mobile-mechanisms-grid');

    const slidesWrapper = wrapper?.querySelector('.swiper-wrapper');

    if (!scentSection || !wrapper || !slidesWrapper || !desktopIndexList || !desktopTitle || !desktopDesc || !desktopMainImg) {
        return;
    }

    let openAccItem = null;
    let openDesktopAccItem = null;
    let suppressAccToggleUntil = 0;
    let lastCarouselActivateAt = 0;

    function setDesktopAccSpineIcon(trigger, open) {
        const icon = trigger?.querySelector('.sculptures-desktop-acc__spine-icon');
        if (icon) icon.textContent = open ? '−' : '+';
    }

    function pauseAccordionDetailVideos() {
        desktopMainImg?.querySelector('video.sculpture-primary-video')?.pause();
        mobileMainImg?.querySelector('video.sculpture-primary-video')?.pause();
    }

    function closeDesktopAccordion() {
        if (!desktopAccordion) return;
        pauseAccordionDetailVideos();
        desktopAccordion.querySelectorAll('.sculptures-desktop-acc__item.is-open').forEach((item) => {
            item.classList.remove('is-open');
            const trigger = item.querySelector('.sculptures-desktop-acc__spine');
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
                setDesktopAccSpineIcon(trigger, false);
            }
        });
        openDesktopAccItem = null;
        sectionRoot.classList.remove('section-sculptures--modal-open', 'section-sculptures--desktop-acc-open');
        desktopAccordion.removeAttribute('data-acc-open');
        if (panelOverlay) {
            panelOverlay.classList.remove('active');
            panelOverlay.setAttribute('aria-hidden', 'true');
        }
    }

    function openDesktopAccordion(type, sculptureIndex, options = {}) {
        if (!desktopAccordion || isSculpturesMobileViewport()) return;
        const item = desktopAccordion.querySelector(`[data-sculptures-desktop-acc="${type}"]`);
        if (!item) return;

        if (options.fromCarousel) {
            suppressAccToggleUntil = Date.now() + 450;
            desktopAccordion.querySelectorAll('.sculptures-desktop-acc__spine').forEach((trigger) => {
                trigger.style.pointerEvents = 'none';
            });
            window.setTimeout(() => {
                desktopAccordion.querySelectorAll('.sculptures-desktop-acc__spine').forEach((trigger) => {
                    trigger.style.pointerEvents = '';
                });
            }, 450);
        }

        desktopAccordion.querySelectorAll('.sculptures-desktop-acc__item').forEach((other) => {
            if (other === item) return;
            other.classList.remove('is-open');
            const otherTrigger = other.querySelector('.sculptures-desktop-acc__spine');
            if (otherTrigger) {
                otherTrigger.setAttribute('aria-expanded', 'false');
                setDesktopAccSpineIcon(otherTrigger, false);
            }
        });

        const trigger = item.querySelector('.sculptures-desktop-acc__spine');
        item.classList.add('is-open');
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
            setDesktopAccSpineIcon(trigger, true);
        }
        openDesktopAccItem = type;
        sectionRoot.classList.add('section-sculptures--modal-open', 'section-sculptures--desktop-acc-open');
        desktopAccordion.setAttribute('data-acc-open', type);
        if (panelOverlay) {
            panelOverlay.classList.add('active');
            panelOverlay.setAttribute('aria-hidden', 'false');
        }

        if (type === 'detail') {
            updateDesktopDetail(typeof sculptureIndex === 'number' ? sculptureIndex : 0);
        }
    }

    function toggleDesktopAccordion(type) {
        if (isSculpturesMobileViewport()) return;
        if (Date.now() < suppressAccToggleUntil) return;
        if (openDesktopAccItem === type) {
            closeDesktopAccordion();
            return;
        }
        openDesktopAccordion(type);
    }

    function updateDesktopMechanisms(detailImages) {
        const urls = Array.isArray(detailImages)
            ? detailImages.filter((u) => typeof u === 'string' && u.length > 0)
            : [];
        if (desktopMechanismsBlock) {
            desktopMechanismsBlock.hidden = urls.length === 0;
        }
        if (!desktopMechanismsGrid) return;
        desktopMechanismsGrid.innerHTML = '';
        desktopMechanismsGrid.appendChild(buildMechanismCells(urls));
    }

    function updateDesktopDetail(index) {
        const s = sculpturesData[index];
        if (!s) return;
        desktopTitle.textContent = '( ' + s.name + ' )';
        desktopDesc.textContent = s.desc;
        applySculpturePrimaryMedia(desktopMainImg, s, { autoplay: true });
        updateDesktopMechanisms(s.detail_images);
        desktopIndexList.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
        const activeLi = desktopIndexList.querySelector(`li[data-sculpture-index="${index}"]`);
        if (activeLi) activeLi.classList.add('active');
    }

    function openDesktopSculptureDetail(index) {
        openDesktopAccordion('detail', index, { fromCarousel: true });
    }

    function updateMobileMechanisms(detailImages) {
        const urls = Array.isArray(detailImages)
            ? detailImages.filter((u) => typeof u === 'string' && u.length > 0)
            : [];
        if (mobileMechanismsWrap) {
            mobileMechanismsWrap.hidden = urls.length === 0;
        }
        if (!mobileMechanismsGrid) return;
        mobileMechanismsGrid.innerHTML = '';
        mobileMechanismsGrid.appendChild(buildMechanismCells(urls));
    }

    function updateMobileDetail(index) {
        const s = sculpturesData[index];
        if (!s || !mobileTitle || !mobileDesc || !mobileMainImg) return;
        mobileTitle.textContent = '( ' + s.name + ' )';
        mobileDesc.textContent = s.desc;
        applySculpturePrimaryMedia(mobileMainImg, s, { autoplay: true });
        updateMobileMechanisms(s.detail_images);
        if (mobileIndexList) {
            mobileIndexList.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
            const activeLi = mobileIndexList.querySelector(`li[data-sculpture-index="${index}"]`);
            if (activeLi) activeLi.classList.add('active');
        }
    }

    function setAccTriggerIcon(trigger, open) {
        const icon = trigger?.querySelector('.sculptures-mobile-acc__trigger-icon');
        if (icon) icon.textContent = open ? '−' : '+';
    }

    function closeMobileAccordion() {
        if (!mobileAccordion) return;
        pauseAccordionDetailVideos();
        mobileAccordion.querySelectorAll('.sculptures-mobile-acc__item.is-open').forEach((item) => {
            item.classList.remove('is-open');
            const trigger = item.querySelector('.sculptures-mobile-acc__trigger');
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
                setAccTriggerIcon(trigger, false);
            }
        });
        openAccItem = null;
        sectionRoot.classList.remove('section-sculptures--acc-open', 'section-sculptures--modal-open');
        if (mobileAccordion) mobileAccordion.removeAttribute('data-acc-open');
        if (mobilePanelOverlay) {
            mobilePanelOverlay.classList.remove('active');
            mobilePanelOverlay.setAttribute('aria-hidden', 'true');
        }
    }

    function openMobileAccordion(type, sculptureIndex, options = {}) {
        if (!mobileAccordion) return;
        const item = mobileAccordion.querySelector(`[data-sculptures-acc="${type}"]`);
        if (!item) return;

        if (options.fromCarousel) {
            suppressAccToggleUntil = Date.now() + 450;
            mobileAccordion.querySelectorAll('.sculptures-mobile-acc__trigger').forEach((trigger) => {
                trigger.style.pointerEvents = 'none';
            });
            window.setTimeout(() => {
                mobileAccordion.querySelectorAll('.sculptures-mobile-acc__trigger').forEach((trigger) => {
                    trigger.style.pointerEvents = '';
                });
            }, 450);
        }

        mobileAccordion.querySelectorAll('.sculptures-mobile-acc__item').forEach((other) => {
            if (other === item) return;
            other.classList.remove('is-open');
            const otherTrigger = other.querySelector('.sculptures-mobile-acc__trigger');
            if (otherTrigger) {
                otherTrigger.setAttribute('aria-expanded', 'false');
                setAccTriggerIcon(otherTrigger, false);
            }
        });

        const trigger = item.querySelector('.sculptures-mobile-acc__trigger');
        item.classList.add('is-open');
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
            setAccTriggerIcon(trigger, true);
        }
        openAccItem = type;
        sectionRoot.classList.add('section-sculptures--acc-open', 'section-sculptures--modal-open');
        mobileAccordion.setAttribute('data-acc-open', type);
        if (mobilePanelOverlay) {
            mobilePanelOverlay.classList.add('active');
            mobilePanelOverlay.setAttribute('aria-hidden', 'false');
        }

        if (type === 'detail') {
            updateMobileDetail(typeof sculptureIndex === 'number' ? sculptureIndex : 0);
        }
    }

    function toggleMobileAccordion(type) {
        if (Date.now() < suppressAccToggleUntil) return;
        if (openAccItem === type) {
            closeMobileAccordion();
            return;
        }
        openMobileAccordion(type);
    }

    const carouselSection = sectionRoot.querySelector('.carousel-section');
    const topLeftText = sectionRoot.querySelector('.top-left-text');
    const desktopNav = sectionRoot.querySelector('.sculptures-desktop-nav');
    let state2Activated = false;
    let sculpturesPinScrollY = null;
    let sculpturesRunwayProgress = 0;
    let sculpturesRunwayComplete = false;
    let sculpturesTouchLastY = 0;
    let sculpturesTouchLastX = 0;
    let sculpturesAccFaded = false;
    let sculpturesPrevPageScrollY = window.scrollY || document.documentElement.scrollTop || 0;

    function isSculpturesScrollLocked() {
        return (
            sculpturesPinScrollY != null &&
            !sculpturesRunwayComplete &&
            !sectionRoot.classList.contains('section-sculptures--modal-open')
        );
    }

    function syncState2FromRunwayProgress() {
        if (state2Activated) return;
        if (sculpturesRunwayProgress >= readSculpturesState2ThresholdPx(sectionRoot)) {
            state2Activated = true;
        }
    }

    function applySculpturesRunwayDelta(delta) {
        const runwayPx = readSculpturesScrollRunwayPx(sectionRoot);
        if (!Number.isFinite(delta) || delta === 0) return;
        if (delta > 0) {
            sculpturesRunwayProgress = Math.min(runwayPx, sculpturesRunwayProgress + delta);
            if (sculpturesRunwayProgress >= runwayPx) sculpturesRunwayComplete = true;
            syncState2FromRunwayProgress();
        } else {
            sculpturesRunwayProgress = Math.max(0, sculpturesRunwayProgress + delta);
            if (sculpturesRunwayProgress < runwayPx) sculpturesRunwayComplete = false;
            syncState2FromRunwayProgress();
        }
        if (delta < 0) {
            sculpturesAccFaded = false;
        } else if (delta > 0 && state2Activated && isSculpturesMobileViewport()) {
            const headerOffset = readSculpturesHeaderOffsetPx(sectionRoot);
            const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
            if (hasScrolledPastMobileAccFadeOffset(headerOffset, scrollY)) {
                sculpturesAccFaded = true;
            }
        }
        if (isSculpturesScrollLocked() && sculpturesPinScrollY != null) {
            window.scrollTo({ top: sculpturesPinScrollY, left: 0, behavior: 'auto' });
        }
        scheduleHeroState();
    }

    function resetSculpturesScrollRunway() {
        sculpturesPinScrollY = null;
        sculpturesRunwayProgress = 0;
        sculpturesRunwayComplete = false;
    }

    function hasScrolledPastSculpturesSection(headerOffset) {
        const shopifyHost = sectionRoot.closest('.shopify-section');
        let next = shopifyHost?.nextElementSibling ?? null;
        while (next && !next.classList.contains('shopify-section')) {
            next = next.nextElementSibling;
        }
        if (next) {
            return next.getBoundingClientRect().top <= headerOffset;
        }
        return sectionRoot.getBoundingClientRect().bottom <= headerOffset;
    }

    function hasScrolledPastSectionHeight(headerOffset) {
        const sectionHeight = sectionRoot.offsetHeight;
        if (sectionHeight <= 0) return false;
        const scrolledIntoSection = headerOffset - sectionRoot.getBoundingClientRect().top;
        return scrolledIntoSection >= sectionHeight;
    }

    function getMobileAccFadeScrollDepthPx(headerOffset, scrollY) {
        const scrolledIntoSection = Math.max(0, headerOffset - sectionRoot.getBoundingClientRect().top);
        const rect = scentSection.getBoundingClientRect();
        const inStickyZone = rect.top <= headerOffset + 1 && rect.bottom > headerOffset;
        if (inStickyZone && sculpturesPinScrollY != null) {
            const pageOverflow = Math.max(0, scrollY - sculpturesPinScrollY);
            return sculpturesRunwayProgress + pageOverflow;
        }
        return scrolledIntoSection;
    }

    function hasScrolledPastMobileAccFadeOffset(headerOffset, scrollY) {
        return getMobileAccFadeScrollDepthPx(headerOffset, scrollY) >= readSculpturesMobileAccFadeOffsetPx(sectionRoot);
    }

    function syncSculpturesAccFade(scrollY, headerOffset) {
        const isMobile = isSculpturesMobileViewport();
        if (!state2Activated) {
            sculpturesAccFaded = false;
            sculpturesPrevPageScrollY = scrollY;
            return false;
        }
        if (!isMobile && !hasScrolledPastSectionHeight(headerOffset)) {
            sculpturesAccFaded = false;
            sculpturesPrevPageScrollY = scrollY;
            return false;
        }
        if (isMobile && !hasScrolledPastMobileAccFadeOffset(headerOffset, scrollY)) {
            sculpturesAccFaded = false;
            sculpturesPrevPageScrollY = scrollY;
            return false;
        }
        const fadeThresholdPx = readSculpturesAccFadeThresholdPx(sectionRoot);
        const delta = scrollY - sculpturesPrevPageScrollY;
        if (delta < -0.5) {
            sculpturesAccFaded = false;
        } else if (delta > 0.5) {
            if (isMobile) {
                sculpturesAccFaded = true;
            } else if (scrollY >= fadeThresholdPx) {
                sculpturesAccFaded = true;
            }
        }
        sculpturesPrevPageScrollY = scrollY;
        return sculpturesAccFaded;
    }

    function syncMobilePanelOverlayForAccFade(accFaded) {
        if (!isSculpturesMobileViewport() || !mobilePanelOverlay) return;
        if (accFaded) {
            mobilePanelOverlay.classList.remove('active');
            mobilePanelOverlay.setAttribute('aria-hidden', 'true');
            return;
        }
        if (openAccItem && sectionRoot.classList.contains('section-sculptures--acc-open')) {
            mobilePanelOverlay.classList.add('active');
            mobilePanelOverlay.setAttribute('aria-hidden', 'false');
        }
    }

    function updateHeroState() {
        const headerOffset = readSculpturesHeaderOffsetPx(sectionRoot);
        const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
        const sectionRect = sectionRoot.getBoundingClientRect();
        const engageScrollY = Math.max(0, sectionRect.top + scrollY - headerOffset);
        const rect = scentSection.getBoundingClientRect();
        const scrolledPastSection = rect.bottom <= 0;
        const inStickyZone = rect.top <= headerOffset + 1 && rect.bottom > headerOffset;
        const pastSculpturesSection = hasScrolledPastSculpturesSection(headerOffset);

        if (inStickyZone) {
            if (sculpturesPinScrollY == null) sculpturesPinScrollY = Math.round(engageScrollY);
            if (!sculpturesRunwayComplete && !sectionRoot.classList.contains('section-sculptures--modal-open')) {
                const runwayPx = readSculpturesScrollRunwayPx(sectionRoot);
                if (scrollY > sculpturesPinScrollY) {
                    const overflow = scrollY - sculpturesPinScrollY;
                    sculpturesRunwayProgress = Math.min(runwayPx, sculpturesRunwayProgress + overflow);
                    syncState2FromRunwayProgress();
                    if (sculpturesRunwayProgress >= runwayPx) {
                        sculpturesRunwayComplete = true;
                    }
                }
                window.scrollTo({ top: sculpturesPinScrollY, left: 0, behavior: 'auto' });
            } else if (scrollY > sculpturesPinScrollY + 0.5) {
                state2Activated = true;
            }
        } else if (!pastSculpturesSection && scrollY < engageScrollY - 48) {
            if (!state2Activated) {
                resetSculpturesScrollRunway();
            } else if (sculpturesRunwayComplete) {
                sculpturesPinScrollY = null;
            }
        } else if (pastSculpturesSection) {
            sculpturesPinScrollY = null;
        }

        scentSection.classList.toggle('state-2', state2Activated);
        sectionRoot.classList.toggle('section-sculptures--desktop-acc-unlocked', state2Activated);
        sectionRoot.classList.toggle('section-sculptures--mobile-acc-unlocked', state2Activated);
        sectionRoot.classList.toggle(
            'section-sculptures--past-section-height',
            hasScrolledPastSectionHeight(headerOffset)
        );
        const accFaded = syncSculpturesAccFade(scrollY, headerOffset);
        sectionRoot.classList.toggle('section-sculptures--scrolled-past', accFaded);
        syncMobilePanelOverlayForAccFade(accFaded);

        if (!isSculpturesMobileViewport()) {
            closeMobileAccordion();
            if (pastSculpturesSection) closeDesktopAccordion();
        } else {
            closeDesktopAccordion();
            if (pastSculpturesSection) closeMobileAccordion();
        }

        const pe = state2Activated ? 'auto' : 'none';
        if (carouselSection) carouselSection.style.pointerEvents = pe;
        if (topLeftText) topLeftText.style.pointerEvents = pe;
        if (desktopNav) desktopNav.style.pointerEvents = pe;
    }

    let heroStateRaf = null;
    function scheduleHeroState() {
        if (heroStateRaf != null) return;
        heroStateRaf = requestAnimationFrame(() => {
            heroStateRaf = null;
            updateHeroState();
        });
    }

    function blockDesktopCarouselVerticalWheel(e) {
        if (isSculpturesMobileViewport()) return false;
        if (!e.target.closest('.carousel-wrapper')) return false;
        const absX = Math.abs(e.deltaX);
        const absY = Math.abs(e.deltaY);
        if (absY >= absX && absY >= 0.5) {
            e.preventDefault();
            return true;
        }
        return false;
    }

    function onSculpturesWheel(e) {
        if (blockDesktopCarouselVerticalWheel(e)) return;
        if (!isSculpturesScrollLocked()) return;
        const runwayPx = readSculpturesScrollRunwayPx(sectionRoot);
        const delta = e.deltaY;
        if (delta > 0 && sculpturesRunwayProgress < runwayPx) {
            e.preventDefault();
            applySculpturesRunwayDelta(delta);
        } else if (delta < 0 && sculpturesRunwayProgress > 0) {
            e.preventDefault();
            applySculpturesRunwayDelta(delta);
        }
    }

    sectionRoot.addEventListener(
        'touchstart',
        (e) => {
            const touch = e.touches[0];
            sculpturesTouchLastY = touch ? touch.clientY : 0;
            sculpturesTouchLastX = touch ? touch.clientX : 0;
        },
        { passive: true }
    );

    sectionRoot.addEventListener(
        'touchmove',
        (e) => {
            if (!isSculpturesScrollLocked()) return;
            const touch = e.touches[0];
            if (!touch) return;
            const dy = sculpturesTouchLastY - touch.clientY;
            const dx = sculpturesTouchLastX - touch.clientX;
            sculpturesTouchLastY = touch.clientY;
            sculpturesTouchLastX = touch.clientX;
            if (e.target.closest('.carousel-wrapper') && Math.abs(dx) >= Math.abs(dy)) return;
            if (dy === 0) return;
            const runwayPx = readSculpturesScrollRunwayPx(sectionRoot);
            if (dy > 0 && sculpturesRunwayProgress < runwayPx) {
                e.preventDefault();
                applySculpturesRunwayDelta(dy);
            } else if (dy < 0 && sculpturesRunwayProgress > 0) {
                e.preventDefault();
                applySculpturesRunwayDelta(dy);
            }
        },
        { passive: false }
    );

    sectionRoot.addEventListener('sculptures-internal-resize', scheduleHeroState);
    window.addEventListener('scroll', scheduleHeroState, { passive: true });
    window.addEventListener('wheel', onSculpturesWheel, { passive: false });
    if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(scheduleHeroState);
        ro.observe(scentSection);
    }
    scheduleHeroState();

    sculpturesData.forEach((s, index) => {
        const item = document.createElement('div');
        item.className = 'carousel-item swiper-slide';
        item.dataset.sculptureIndex = String(index);
        const idDisp = formatSculptureCounterDisplay(s.id);
        item.innerHTML = `<div class="sculpture-img"></div><div class="item-info ease-display-font">${s.name} <span>(${idDisp})</span></div>`;
        const imgEl = item.querySelector('.sculpture-img');
        if (imgEl) {
            if (applySculpturePrimaryMedia(imgEl, s)) {
                ensureSculptureVideoHoverZone(item);
            }
        }
        slidesWrapper.appendChild(item);

        const desktopLi = document.createElement('li');
        desktopLi.textContent = `( ${formatSculptureCounterDisplay(s.id)} )`;
        desktopLi.dataset.sculptureIndex = String(index);
        desktopLi.addEventListener('click', () => updateDesktopDetail(index));
        desktopIndexList.appendChild(desktopLi);

        if (mobileIndexList) {
            const mobileLi = document.createElement('li');
            mobileLi.textContent = `( ${formatSculptureCounterDisplay(s.id)} )`;
            mobileLi.dataset.sculptureIndex = String(index);
            mobileLi.addEventListener('click', () => updateMobileDetail(index));
            mobileIndexList.appendChild(mobileLi);
        }
    });

    bindSculptureDetailImageNavigation(
        desktopMainImg,
        desktopIndexList,
        sculpturesData.length,
        updateDesktopDetail
    );
    if (mobileMainImg && mobileIndexList) {
        bindSculptureDetailImageNavigation(
            mobileMainImg,
            mobileIndexList,
            sculpturesData.length,
            updateMobileDetail
        );
    }

    const originalSlideCount = sculpturesData.length;
    const slidesPerViewDesktop = 2.5;
    const slidesPerViewMobile = 1.5;
    const minSlidesForLoop = Math.ceil(Math.max(slidesPerViewMobile, slidesPerViewDesktop)) * 2 + 1;
    const originalSlides = Array.from(slidesWrapper.querySelectorAll('.swiper-slide:not([data-swiper-cloned])'));

    if (originalSlideCount > 0 && originalSlideCount < minSlidesForLoop) {
        for (let i = slidesWrapper.children.length; i < minSlidesForLoop; i += 1) {
            const source = originalSlides[i % originalSlideCount];
            const clone = source.cloneNode(true);
            clone.setAttribute('data-swiper-cloned', 'true');
            clone.removeAttribute('data-sculpture-video-hover-bound');
            slidesWrapper.appendChild(clone);
            if (clone.querySelector('video.sculpture-primary-video')) {
                ensureSculptureVideoHoverZone(clone);
            }
        }
    }

    const resolveCarouselSlideIndex = (slideEl, swiper) => {
        if (!slideEl) return NaN;
        const fromDataset = parseInt(slideEl.dataset.sculptureIndex, 10);
        if (!Number.isNaN(fromDataset)) return fromDataset;
        if (!swiper || typeof swiper.realIndex !== 'number' || swiper.realIndex < 0) return NaN;
        return swiper.realIndex;
    };

    const openSculptureByCarouselIndex = (index) => {
        if (Number.isNaN(index) || index < 0 || index >= sculpturesData.length) return;
        if (isSculpturesMobileViewport()) {
            openMobileAccordion('detail', index, { fromCarousel: true });
        } else {
            openDesktopSculptureDetail(index);
        }
    };

    const activateCarouselSlide = (slideEl, swiper, event) => {
        if (!slideEl) return;
        const now = Date.now();
        if (now - lastCarouselActivateAt < 400) return;
        lastCarouselActivateAt = now;

        if (event) {
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }
            if (event.cancelable) event.preventDefault();
        }

        const index = resolveCarouselSlideIndex(slideEl, swiper);
        window.setTimeout(() => openSculptureByCarouselIndex(index), 0);
    };

    let sculpturesSwiper = null;
    if (typeof Swiper !== 'function') {
        console.warn('Sculptures carousel: Swiper is not loaded (swiper-bundle.min.js).');
    } else {
        try {
            const loopedSlidesCount = Math.max(originalSlideCount, Math.ceil(slidesPerViewDesktop) + 1);
            const initialSlideIndex = originalSlideCount > 1 ? 1 : 0;
            const sculpturesSwiperMobile = isSculpturesMobileViewport();
            sculpturesSwiper = new Swiper(wrapper, {
                slidesPerView: slidesPerViewMobile,
                spaceBetween: 28,
                loop: originalSlideCount > 1,
                loopedSlides: loopedSlidesCount,
                initialSlide: initialSlideIndex,
                speed: sculpturesSwiperMobile ? 400 : 550,
                grabCursor: !sculpturesSwiperMobile,
                touchEventsTarget: 'container',
                passiveListeners: sculpturesSwiperMobile,
                touchStartPreventDefault: !sculpturesSwiperMobile,
                touchAngle: sculpturesSwiperMobile ? 30 : 45,
                threshold: sculpturesSwiperMobile ? 8 : 5,
                preventClicks: false,
                preventClicksPropagation: false,
                resistanceRatio: 0.85,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                breakpoints: {
                    992: {
                        slidesPerView: slidesPerViewDesktop,
                        spaceBetween: 50,
                        loopedSlides: loopedSlidesCount,
                        grabCursor: true,
                        passiveListeners: false,
                        touchAngle: 45,
                        threshold: 5,
                    },
                },
                on: {
                    touchStart() {
                        wrapper.classList.add('is-touching');
                    },
                    touchEnd() {
                        wrapper.classList.remove('is-touching');
                    },
                    tap(swiper, event) {
                        const slide = event.target.closest('.swiper-slide');
                        if (!slide) return;
                        activateCarouselSlide(slide, swiper, event);
                    },
                    click(swiper, event) {
                        const slide = event.target.closest('.swiper-slide');
                        if (!slide) return;
                        activateCarouselSlide(slide, swiper, event);
                    },
                },
            });

            let carouselTouchMoved = false;
            let carouselTouchStartX = 0;
            let carouselTouchStartY = 0;
            const CAROUSEL_TAP_MOVE_PX = 14;

            wrapper.addEventListener(
                'touchstart',
                (e) => {
                    carouselTouchMoved = false;
                    const touch = e.touches[0];
                    if (!touch) return;
                    carouselTouchStartX = touch.clientX;
                    carouselTouchStartY = touch.clientY;
                },
                { passive: true }
            );

            wrapper.addEventListener(
                'touchmove',
                (e) => {
                    const touch = e.touches[0];
                    if (!touch) return;
                    if (
                        Math.hypot(
                            touch.clientX - carouselTouchStartX,
                            touch.clientY - carouselTouchStartY
                        ) > CAROUSEL_TAP_MOVE_PX
                    ) {
                        carouselTouchMoved = true;
                    }
                },
                { passive: true }
            );

            wrapper.addEventListener(
                'touchend',
                (e) => {
                    if (carouselTouchMoved) return;
                    if (sculpturesSwiper && sculpturesSwiper.allowClick === false) return;
                    const slide = e.target.closest('.swiper-slide');
                    if (!slide || !slidesWrapper.contains(slide)) return;
                    activateCarouselSlide(slide, sculpturesSwiper, e);
                },
                { passive: false }
            );
        } catch (err) {
            console.warn('Sculptures Swiper init failed:', err);
        }
    }

    let carouselWheelAccum = 0;
    let carouselWheelCooldownUntil = 0;
    const CAROUSEL_WHEEL_THRESHOLD = 180;
    const CAROUSEL_WHEEL_COOLDOWN_MS = 550;

    function onCarouselWheel(e) {
        if (isSculpturesMobileViewport()) return;

        const absX = Math.abs(e.deltaX);
        const absY = Math.abs(e.deltaY);
        if (absY >= absX && absY >= 0.5) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        if (!state2Activated || !sculpturesSwiper) return;
        if (sectionRoot.classList.contains('section-sculptures--modal-open')) return;
        if (absX < 0.5) return;

        e.preventDefault();
        e.stopPropagation();

        if (Date.now() < carouselWheelCooldownUntil) {
            carouselWheelAccum = 0;
            return;
        }

        carouselWheelAccum += e.deltaX;
        if (Math.abs(carouselWheelAccum) < CAROUSEL_WHEEL_THRESHOLD) return;

        if (carouselWheelAccum > 0) {
            sculpturesSwiper.slideNext();
        } else {
            sculpturesSwiper.slidePrev();
        }
        carouselWheelAccum = 0;
        carouselWheelCooldownUntil = Date.now() + CAROUSEL_WHEEL_COOLDOWN_MS;
    }

    if (wrapper) {
        wrapper.addEventListener('wheel', onCarouselWheel, { passive: false });
    }

    const refreshSculpturesSwiper = () => {
        if (!sculpturesSwiper || typeof sculpturesSwiper.update !== 'function') return;
        try {
            sculpturesSwiper.update();
        } catch (_) {
            /* noop */
        }
    };

    sectionRoot.addEventListener('sculptures-internal-resize', refreshSculpturesSwiper);
    window.addEventListener('load', refreshSculpturesSwiper);

    if (panelOverlay) {
        panelOverlay.addEventListener('click', () => {
            if (!isSculpturesMobileViewport()) closeDesktopAccordion();
        });
    }

    if (mobilePanelOverlay) {
        mobilePanelOverlay.addEventListener('click', () => {
            if (isSculpturesMobileViewport()) closeMobileAccordion();
        });
    }

    const desktopAccEl = sectionRoot.querySelector('.sculptures-desktop-acc');
    const mobileAccEl = mobileAccordion;

    if (desktopAccordion) {
        desktopAccordion.querySelectorAll('[data-sculptures-desktop-acc-trigger]').forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const type = trigger.getAttribute('data-sculptures-desktop-acc-trigger');
                if (type === 'detail' || type === 'program') toggleDesktopAccordion(type);
            });
        });
    }

    document.addEventListener('click', (e) => {
        if (isSculpturesMobileViewport()) {
            if (!openAccItem) return;
            if (mobileAccEl?.contains(e.target)) return;
            closeMobileAccordion();
            return;
        }
        if (!openDesktopAccItem) return;
        if (desktopAccEl?.contains(e.target)) return;
        if (e.target.closest('.sculptures-desktop-nav')) return;
        closeDesktopAccordion();
    });

    sectionRoot.querySelectorAll('.sculptures-desktop-nav [data-sculptures-panel]').forEach((el) => {
        const open = () => {
            if (isSculpturesMobileViewport()) return;
            const type = el.getAttribute('data-sculptures-panel');
            if (type === 'detail' || type === 'program') toggleDesktopAccordion(type);
        };
        el.addEventListener('click', open);
        el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                open();
            }
        });
    });

    if (mobileAccordion) {
        mobileAccordion.querySelectorAll('[data-sculptures-acc-trigger]').forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const type = trigger.getAttribute('data-sculptures-acc-trigger');
                if (type === 'detail' || type === 'program') toggleMobileAccordion(type);
            });
        });

        mobileAccordion.querySelectorAll('[data-sculptures-acc-close]').forEach((btn) => {
            btn.addEventListener('click', () => closeMobileAccordion());
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    applySculpturesHeaderOffsetToDom();
    document.querySelectorAll('.section-sculptures').forEach(initSculpturesSection);
    window.addEventListener('resize', onWindowResizeForSculptures);
    window.addEventListener('load', onWindowResizeForSculptures);
});
/* end Sculptures section */
